import i18n from "app/i18n";
import ru from "./ru";
import en from "./en";

i18n.addResourceBundle("ru", ru.namespace, ru);
i18n.addResourceBundle("en", en.namespace, en);
